import { render } from "./ProfileIntro.vue?vue&type=template&id=4db829f8&ts=true"
import script from "./ProfileIntro.vue?vue&type=script&lang=ts"
export * from "./ProfileIntro.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__